import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { ThunkResult } from '../models';
import { beginAjaxCall } from './ajaxStatusActions';
import API from '../constants/apiEndpoints';
import { constants } from '../constants/constants';
import * as types from './actionTypes';
import { msalFetch } from '../components/auth/Auth-Utils';
const fileDownload = require('js-file-download');

export const exportEventHistoryCsv = (
    installBaseID: string
): ThunkResult<any> => {
    return (dispatch, getState) => {
        dispatch(beginAjaxCall());

        const axiosOptions: AxiosRequestConfig = {
            method: 'get',
            params: {
                installBaseID
            }
        };

        const url = API.eventHistory.exportCsv;
        return msalFetch(url, axiosOptions)
            .then((data: AxiosResponse<any>) => {
                if (!data.data) {
                    throw new Error('missing data');
                } else {
                    dispatch({ type: types.EXPORT_EVENT_HISTORY_CSV_SUCCESS });
                    const file = data.data;
                    // The filename is already set by the backend in Content-Disposition header
                    // but we'll use a default name pattern here
                    const filename = `event-history-${installBaseID}.csv`;
                    fileDownload(file, filename);
                }
            })
            .catch((error: any) => {
                dispatch({
                    type: types.EXPORT_EVENT_HISTORY_CSV_FAILED,
                    error,
                    axiosOptions
                });
                constants.handleError(error, 'export event history csv');
            });
    };
};
